"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Halon = void 0;
var halon_1 = require("./halon");
Object.defineProperty(exports, "Halon", { enumerable: true, get: function () { return halon_1.Halon; } });
//# sourceMappingURL=index.js.map